import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { Building2, IndianRupee, TrendingDown, Clock, Shield, BarChart3 } from 'lucide-react';

export default function WarehousesPage() {
  return (
    <SolutionPageTemplate
      slug="warehouses"
      title="BESS for Warehouses"
      subtitle="Warehouses & Industrial"
      description="Peak shaving, backup power, and solar integration for warehouses and industrial facilities. Reduce demand charges and ensure continuous operations."
      heroImage="/images/voltide-battery-pack-large.png"
      path="/solutions/warehouses"
      sectorLabel="warehouses"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: TrendingDown, title: 'Peak Shaving', desc: 'Reduce peak demand charges by 20-40% with intelligent load management.' },
        { icon: IndianRupee, title: 'Lower ToD Costs', desc: 'Charge during off-peak hours, discharge during peak tariff periods.' },
        { icon: Shield, title: 'Reliable Backup', desc: 'Keep conveyor systems, cold storage, and security running during outages.' },
        { icon: Clock, title: 'Fast Deployment', desc: 'Containerised systems deploy quickly with minimal civil work.' },
        { icon: Building2, title: 'Scalable', desc: 'Start with one unit, add more as your facility grows. Modular design.' },
        { icon: BarChart3, title: 'Energy Analytics', desc: 'Detailed consumption analytics help optimize your overall energy strategy.' },
      ]}
      howItWorks={[
        { title: 'Energy Audit', desc: 'We analyze your load profile, demand patterns, and tariff structure to design the optimal solution.' },
        { title: 'System Installation', desc: 'Containerised BESS placed in your yard or loading area. Grid-connected with your existing panel.' },
        { title: 'Automated Operation', desc: 'Smart EMS manages charge/discharge automatically based on tariff schedules and load forecasting.' },
      ]}
      faqs={[
        { q: 'How much can I save on peak demand charges?', a: 'Typical savings of 20-40% on demand charges depending on your load profile and tariff structure. The exact number depends on your peak-to-average demand ratio.' },
        { q: 'Can BESS support heavy industrial loads?', a: 'Yes. Our systems range from 125 kW to 750+ kW, suitable for conveyor systems, cold storage, processing equipment, and more.' },
        { q: 'What about fire safety in a warehouse?', a: 'Our BESS containers include integrated fire suppression systems and meet all relevant safety standards. The containerised design provides additional isolation.' },
      ]}
      productFilter={p => p.pcs_kw >= 250}
    />
  );
}
